import React from 'react';
import { View, Text, StyleSheet, Platform } from 'react-native';
import CS from '../constants/Styles';
import Colors from '../constants/Colors';
import { createDrawerNavigator, DrawerContentScrollView, DrawerItemList, DrawerItem } from '@react-navigation/drawer';
// import { PersonalProfileScreen, CompanyProfileScreen, FeeCalculatorScreen, ResourcesScreen } from './More';
import { PersonalProfileScreen, CompanyProfileScreen, FeeCalculatorScreen, TestScreen } from './More';
import MainTabs from './MainTabs';
import UserState from '../src/contexts/UserState';
import { Loader, Storage, Alert } from '../components';
import * as rtApi from '../components/Api';
import UserAvatar from '../components/Users/UserAvatar';
import * as Device from 'expo-device';
import * as Notifications from 'expo-notifications';
// import * as Permissions from 'expo-permissions';
import * as WebBrowser from 'expo-web-browser';
import { useLinkTo } from '@react-navigation/native';
import { isDev } from '../constants/DevProd';

const MoreDrawer = ({ navigation }) => {
  const [user, setUser] = React.useContext(UserState);
  const [expoPushToken, setExpoPushToken] = React.useState('');
  const [alertOptions, setAlertOptions] = React.useState({});
  const [fcWidgetDataSet, setFcWidgetDataSet] = React.useState(false);
  let fcInterval = null;
  const Drawer = createDrawerNavigator();
  const linkTo = useLinkTo();
  let interval = null;
  // const interval1 = 20; // 20 secs
  // const interval2 = 25; // 25 secs
  const interval1 = 2400; // 40 mins
  const interval2 = 2700; // 45 mins
  let inactiveAlertShown1 = false;
  let inactiveAlertShown2 = false;

  React.useEffect(() => {
    if(Platform.OS !== 'web' && Device.isDevice){
      registerForPushNotificationsAsync().then(token => {
        setExpoPushToken(token);
        saveExpoPushToken(token);
      }).catch(err => {
        console.log('registerForPushNotificationsAsync catch: ', err);
      });
      checkForDeepLink();
    }
    return () => rtApi.cancel();
  }, []);

  React.useEffect(() => {
    interval = setInterval(checkInactivity, 1000);
    return () => clearInterval(interval);
  }, [])

  React.useEffect(() => {
    if(Platform.OS === 'web'){
      const link = window.sessionStorage.rtProjectDeepLink;
      if(link){
        window.sessionStorage.rtProjectDeepLink = '';
        linkTo(link);
      }
    }
  }, [])

  React.useEffect(() => {
    if(Platform.OS === 'web'){
      console.log('useEffect user: ', user);
      if (user && typeof user === 'object' && user !== null) {
        console.log('got user, setting fc chat stuff', window.fcWidget);
        fcInterval = setInterval(setFcData, 1000);
      }
    }
    return () => clearInterval(fcInterval);
  }, [user])

  const setFcData = () => {
    try{
      if (!fcWidgetDataSet && window.fcWidget){
        window.fcWidget.setExternalId(user.account_id);
        window.fcWidget.user.setFirstName(user.first_name);
        window.fcWidget.user.setLastName(user.last_name);
        window.fcWidget.user.setEmail(user.email_address);
        setFcWidgetDataSet(true);
      }
    }catch(err){
      console.log('err: ', err);
      setFcWidgetDataSet(false);
    }
  }

  const checkInactivity = async () => {
    let apiRequestTime = await Storage.getItem('apiRequestTime');
    if(apiRequestTime){
      let elapsed = parseInt(Math.floor((Date.now() - apiRequestTime) / 1000));
      // console.log(`${elapsed} seconds have elapsed since any activity has occured`)
      if(elapsed > interval1){
        if(elapsed >= interval1 && !inactiveAlertShown1){ // 40 minutes
          console.log('match interval1');
          setAlertOptions({
            visible: true,
            title: 'Are you still there?',
            message: `You haven't interacted in over 40 minutes. Are you still there? To keep your account secure, we will automatically log you out if you do not respond.`,
            buttons: [
              {
                text: "I'm Still Here",
                onPress: () => keepActive(),
                style: 'cancel',
              },
            ]
          })
          inactiveAlertShown1 = true;
        }else if(elapsed >= interval2 && !inactiveAlertShown2){
          console.log('match interval2');
          setAlertOptions({
            visible: true,
            title: 'Timeout reached',
            message: "We have not heard back from you. In order to maintain the highest levels of security, we have logged you out.",
            buttons: [
              {
                text: "Ok",
                onPress: () => inactiveLogout(),
                style: 'cancel',
              },
            ]
          })
          inactiveAlertShown2 = true;
          clearInterval(interval);
        }
      }else{
        if (inactiveAlertShown1) { inactiveAlertShown1 = false; }
        if (inactiveAlertShown2) { inactiveAlertShown2 = false; }
      }
    }
  }
  const keepActive = async () => {
    console.log('keepActive');
    return rtApi.get(`money`);
  }
  const inactiveLogout = () => {
    inactiveAlertShown1 = false;
    inactiveAlertShown2 = false;
    performLogout()
  }
  const performLogout = () => {
    console.log('logout');
    rtApi.get('logout')
    .then(data => {
      setUser({ isLoggedIn: false });
      rtApi.cancel();
      Storage.removeItem('rtJWT');
    }).catch(err => {
      console.log('logout error:', err);
    });
  }

  const checkForDeepLink = async () => {
    if (Platform.OS !== 'web') {
      setTimeout(async () => {
        const deepLink = await Storage.getItem('deepLink');
        console.log('deepLink: ', deepLink);
        // alert(deepLink);
        if (deepLink) {
          linkTo(`/${deepLink}`);
          Storage.removeItem('deepLink');
        }
      }, 250);
    }
  }

  const registerForPushNotificationsAsync = async () => {
    let token;
    if (Device.isDevice) {
      // const { status: existingStatus } = await Permissions.getAsync(Permissions.NOTIFICATIONS);
      const { status: existingStatus } = await Notifications.getPermissionsAsync();
      let finalStatus = existingStatus;
      if (existingStatus !== 'granted') {
        // const { status } = await Permissions.askAsync(Permissions.NOTIFICATIONS);
        const { status } = await Notifications.requestPermissionsAsync();
        finalStatus = status;
      }
      if (finalStatus !== 'granted') {
        throw('Failed to get push token for push notification!');
      }
      token = (await Notifications.getExpoPushTokenAsync()).data;
      console.log('pushToken', token);
    } else {
      throw('Must use physical device for Push Notifications');
    }

    if (Platform.OS === 'android') {
      Notifications.setNotificationChannelAsync('default', {
        name: 'default',
        importance: Notifications.AndroidImportance.MAX,
        vibrationPattern: [0, 250, 250, 250],
        lightColor: '#FF231F7C',
      });
    }

    return token;
  };
  const saveExpoPushToken = async (token) => {
    let oldToken = 'ExponentPushToken['+user.expo_push_token+']';
    if(oldToken === token){ return; }
    console.log('saveExpoPushToken1', token);
    // if(typeof token === 'object') return;
    let fd = new FormData();
    fd.append('expo_push_token', token);

    return rtApi.put(`users/${user.id}`, fd)
    .then(data => {
      if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
      console.log('saveExpoPushToken2', data);
      setUser(user => {
        return {
          ...user,
          expo_push_token: token.replace('ExponentPushToken[', '').replace(']',''),
        }
      })
    })
    .catch((error) => {
      console.log(error);
    });
  }

  return (
    <>
      <Alert options={alertOptions} setOptions={setAlertOptions} />
      <Drawer.Navigator
        initialRouteName='MainTabs'
        drawerContent={props => <CustomDrawerContent {...props} />}
        screenOptions={{
          drawerStyle: {
            backgroundColor: Colors.blue3,
            borderLeftColor: Colors.blue3,
          },
          drawerPosition: Platform.OS === 'web' ? 'left' : 'right', // must be left on web or drawer can always be scrolled to
          headerShown: false,
          drawerLabelStyle: {
            color: Colors.lightText,
            fontWeight: 'bold',
            fontSize: 18,
          },
        }}
      >
        <Drawer.Screen
          name='MainTabs'
          options={{ title: 'Back' }}
          component={MainTabs} 
        />
        <Drawer.Screen
          name='PersonalProfile'
          options={{ title: 'My Profile' }}
          component={PersonalProfileScreen}
        />
        {user.isContractor &&
        <Drawer.Screen
          name='CompanyProfile'
          options={{ title: 'My Company Profile' }}
          component={CompanyProfileScreen}
        />
        }
        <Drawer.Screen
          name='FeeCalculator'
          options={{ title: 'Fee Calculator' }}
          component={FeeCalculatorScreen}
        />
        {isDev && 
          <Drawer.Screen
            name='TestScreen'
            options={{ title: 'Test Screen', headerShown: true }}
            component={TestScreen}
          />
        }
      </Drawer.Navigator>
    </>
  );

}

const CustomDrawerContent = (props) => {
  const [user, setUser] = React.useContext(UserState);
  const [loading, setLoading] = React.useState(false);

  const subDomain = __DEV__ ? 'dev' : 'www';

  const performLogout = () => {
    console.log('logout');
    setLoading(true);
    rtApi.get('logout')
    .then(data => {
      setUser({ isLoggedIn: false  });
      rtApi.cancel();
      Storage.removeItem('rtJWT');
    }).catch(err => {
      console.log('logout error:', err);
    }).finally(() => {
      setLoading(false);
    })
  }
  const goToWebsite = () => {
    const page = user.isContractor ? 'how_it_works_contractors' : 'how_it_works_homeowners';
    WebBrowser.openBrowserAsync(`https://${subDomain}.renovationtrust.com/${page}`);
  }
  const goToResources = () => {
    WebBrowser.openBrowserAsync('https://renovationtrust.freshdesk.com/support/home');
  }
  const goToPrivacyPolicy = () => {
    WebBrowser.openBrowserAsync(`https://${subDomain}.renovationtrust.com/privacy`);
  }
  const help = () => {
    WebBrowser.openBrowserAsync(`https://${subDomain}.renovationtrust.com/contact_us?chat=${user.account_id}&first_name=${user.first_name}&last_name=${user.last_name}&email_address=${user.email_address}`);
  }
  const openChat = () => {
    if(Platform.OS === 'web' && window.fcWidget){
      window.fcWidget.open();
      window.fcWidget.show();
    }else{
      help();
    }
  }
  return (
    <DrawerContentScrollView {...props}>
      <Loader animating={loading} />
      <DrawerHeader />
      <DrawerItemList {...props} />
      {Platform.OS === 'web'
      ?
        <DrawerItem label="Chat" onPress={openChat} labelStyle={styles.drawerItemLabel} style={styles.drawerItem} />
      : null}
      <DrawerItem label="Resources" onPress={goToResources} labelStyle={styles.drawerItemLabel} style={styles.drawerItem} />
      <DrawerItem label="How it Works" onPress={goToWebsite} labelStyle={styles.drawerItemLabel} style={styles.drawerItem} />
      <DrawerItem label="Help" onPress={help} labelStyle={styles.drawerItemLabel} style={styles.drawerItem} />
      <DrawerItem label="Privacy Policy" onPress={goToPrivacyPolicy} labelStyle={styles.drawerItemLabel} style={styles.drawerItem} />
      <DrawerItem label="Logout" onPress={performLogout} labelStyle={styles.drawerItemLabel} style={styles.drawerItem} />
    </DrawerContentScrollView>
  );
}

const DrawerHeader = (props) => {
  const [user, setUser] = React.useContext(UserState);
  return (
    <View style={styles.drawerHeader}>
      <View style={styles.avatarContainer}>
        <UserAvatar size='large' userId={user.id} avatar={user.avatar} verified={user.verified} />
      </View>
      <Text style={[CS.mediumText, CS.boldText, CS.lightText]}>{user.full_name}</Text>
      <Text style={[CS.smallText, CS.lightText, { marginTop: 5 }]}>#{user.account_id}</Text>
    </View>
  )
}

const styles = StyleSheet.create({
  drawerHeader: {
    borderStyle: 'solid',
    borderColor: Colors.grey,
    borderBottomWidth: 1,
    padding: 10,
    paddingBottom: 20,
    marginBottom: 20,
    alignItems: 'center',
  },
  avatarContainer: {
    marginBottom: 10,
  },
  avatar: {
    width: 120,
    height: 120,
  },
  drawerItemLabel: {
    color: Colors.lightText,
    fontWeight: 'bold',
    fontSize: 18,
  },
});

export default MoreDrawer;